import React from 'react';
import { Box } from '@mui/material';
import { LayoutItem } from 'react-grid-layout';
import { ReactComponent as SmartSwitchErrorIcon } from '../../../../../../../../assets/dashboard/SmartSwitchError.svg';
import {
  ILabelValuePanel,
  ISmartSwitchDeviceErrorPanel,
} from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import LabelValuePanel from '../../../../../../../../theme/ui/Dashboard/LabelValuePanel/LabelValuePanel';
import { useTranslation } from 'react-i18next';
import useAirConnectStatus from '../../../../../../../../service/device/CommanderAPI/hooks/useAirConnectStatus';

export interface SmartSwitchDeviceErrorPanelProps {
  panel: ISmartSwitchDeviceErrorPanel;
  layout?: LayoutItem | undefined;
}

function SmartSwitchDeviceErrorPanel(props: SmartSwitchDeviceErrorPanelProps) {
  const { panel, layout } = props;
  const { t } = useTranslation();
  const { isFetching, currentData, error } = useAirConnectStatus(panel);

  const labelValuePanel: ILabelValuePanel = {
    type: 'LABEL_VALUE',
    id: `smartswitch_device_error`,
    title: panel.title,
    icon: <SmartSwitchErrorIcon height={'100%'} />,
    content: (
      <Box
        width="100%"
        height={'100%'}
        minWidth={120}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        {currentData?.shellyRemoved ?? 0}
      </Box>
    ),
    loading: isFetching,
    error: error ? t('dashboard.error.fetching') : undefined,
  };
  return <LabelValuePanel panel={labelValuePanel} layout={layout} />;
}

export default SmartSwitchDeviceErrorPanel;
